// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8943":"a721cdaf","9824":"a5909d33"}[chunkId] + ".chunk.css";
};